import type { VoidFunctionComponent } from 'react';
import { Modal } from 'react-bootstrap';

import type { MessageOptions } from '../../../modals/ModalPlanSelector';
import type { FeatureDescription} from '../../billing/features/consts';
import { getFeatureDetails } from '../../billing/features/consts';
import PlanCards from './PlanCards';
import PlansHeader from './PlansHeader';
import Button from '../../../generic/Button';
import { window } from '../../../../globals';
import styles from './ModalPlans.module.less';

type PlanType = 'Enterprise' | 'Business';

type ModalPlanTitleProps = {
  plan: PlanType;
  feature?: FeatureDescription | null;
};

const ModalPlanTitle: VoidFunctionComponent<ModalPlanTitleProps> = ({
  plan,
  feature,
}: ModalPlanTitleProps) => {
  if (feature) {
    if (plan === 'Enterprise') {
      return (
        <>
          <strong>{feature.name}</strong>
          {' '}
          available with an <strong>Enterprise</strong> plan
        </>
      );
    }

    return (
      <>
        <strong>{feature.name}</strong>
        {' '}
        available with an <strong>Business</strong> plan
      </>
    );
  }

  if (plan === 'Enterprise') {
    return <>Available with an <strong>Enterprise</strong> plan</>;
  }

  return <>Available with a <strong>Business</strong> plan</>;
};

type ModalPlansProps = {
  onHide: () => void;
  isShowing: boolean;
  messageOptions?: MessageOptions;
};

const ModalPlans: VoidFunctionComponent<ModalPlansProps> = ({
  onHide,
  isShowing,
  messageOptions,
}: ModalPlansProps) => {
  const featureDetails = getFeatureDetails(messageOptions?.focusFeature);

  const onClickViewPlans = () => {
    window.location = ('/account/settings/billing/wip?tab=Plans');
  };

  return (
    <Modal
      show={isShowing}
      onHide={onHide}
      dialogClassName="plan-selector-modal-container"
    >
      <Modal.Header closeButton />
      <Modal.Body>
        <div className={styles.title}>
          <ModalPlanTitle plan={messageOptions?.tier as PlanType} feature={featureDetails} />
        </div>
        <PlansHeader hideLabel />
        <PlanCards />
        <div className={styles.viewPlanDetails}>
          <Button
            onClick={onClickViewPlans}
            size="medium"
            type="outline"
          >
            View Full Plan Details
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalPlans;
